// extracted by mini-css-extract-plugin
module.exports = {"Nav":"LandingPageNavigation-module--Nav--3bF6i","Logo":"LandingPageNavigation-module--Logo--80kkW","NavList":"LandingPageNavigation-module--NavList--3Imh7"};